import React, { PureComponent } from 'react';
import { PrimaryButton, Icon } from 'appSrc/components/UI';
import { FormTextField, FormSelect, FormTextArea, FormToggle } from 'appSrc/components/UI/ReduxForm';
import { connect } from 'react-redux';
import style from './styles/style.module.css';
import { Field, reduxForm, SubmissionError, Form, change } from 'redux-form';
import ImageCropModalWrapper from 'appSrc/components/ImageUpload/CropModalWrapper';
import formValidate from 'appSrc/utils/formValidate';
import Edit from 'appSrc/components/Icons/Edit';
import { dAPI } from 'appSrc/api';
import { VideoImageSelector } from 'appSrc/components/Shards';
import { parseYouTubeUrl } from 'appSrc/utils';
import defaultProfileIcon from 'appSrc/assets/img/profile.svg';
import CategorySelectModal from 'appSrc/AdminPanel/pages/Modals/Category/Select';

class UserForm extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            selectedImage: this.props.initialValues.avatar,
            professionOptions: [],
            introVideo: this.props.initialValues.intro_video,
            categories: props.initialValues.categories || [],
        };
    }
    componentDidMount() {
        this.props.getProfessionOptions()
        .then( ( options ) => {
            options.push( options.shift() );
            options.unshift( { title: '', id: null } );
            this.setState( {
                professionOptions: options.map( option => ( {
                    text: option.title,
                    value: option.id,
                } ) ),
            } );
        } );
    }
    updateCategories = ( { checked, data } ) => {
        this.categoryIds = checked;
        this.props.changeFieldValue( 'categories', data );

        this.setState( {
            categories: data,
            showCategorySelect: false,
        } );
    }
    cropFinish = ( imageData ) => {
        this.setState( {
            selectedImage: imageData,
        } );
        if( imageData != null ) {
            this.props.changeFieldValue( 'avatar', imageData );
        }
    }
    updateVideo = ( values ) => {
        if( values == null ) {
            this.props.changeFieldValue( 'bannerImage', null );
            this.props.changeFieldValue( 'intro_video', null );
            this.setState( {
                introVideo: null,
                showVideoSelect: false,
            } );
        } else {
            var imageData = values.selectedImage;
            var ytUrl = values.youtubeLink;
            if( imageData != null ) {
                this.props.changeFieldValue( 'bannerImage', imageData );
                this.props.changeFieldValue( 'intro_video', parseYouTubeUrl( ytUrl ) );
                this.setState( {
                    introVideo: parseYouTubeUrl( ytUrl ),
                    showVideoSelect: false,
                } );
            }
        }
    }
    submitHandler = ( values ) => {
        if( values.usertype == 'verified creator' && !values.slug ) {
            throw new SubmissionError( { slug: 'Verified creators require a slug' } );
        }
        if( !values.slug ) {
            values.slug = null;
        }
        values.categories = this.state.categories;
        this.props.submitHandler( values );
    }
    render() {
        const { handleSubmit } = this.props;
        const { categories, selectedImage, professionOptions, introVideo } = this.state;

        return (
            <div>
                <Form className={ style.individualUser }
                onSubmit={ handleSubmit( this.submitHandler ) }>
                    <div className={ style.topLevel }>
                        <div className={ style.imageWrapper }>
                            <ImageCropModalWrapper
                            onFinish={ this.cropFinish }>
                                <div>
                                    <img src={ selectedImage || defaultProfileIcon } />
                                    <span className={ style.editWrapper }><Edit style={ { display: 'inline-block' } } /></span>
                                </div>
                            </ImageCropModalWrapper>
                        </div>
                        <div className={ style.detailsWrapper }>
                            <Field
                            id='displayName'
                            name='displayName'
                            label='Display Name'
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id='slug'
                            name='slug'
                            label='Profile Slug'
                            component={ FormTextField }
                            validate={ formValidate.reduxStandard.slug }
                            fullWidth />

                            <Field
                            id='emailAddress'
                            name='emailAddress'
                            label='Email Address'
                            component={ FormTextField }
                            fullWidth />

                            <div className={ style.uncontrolledField } data-name='intro_video'>
                                <div className={ style.fieldTitle }>Intro Video:</div>
                                <div className={ style.floatWrapper }>
                                    <p onClick={ () => { this.setState( { showVideoSelect: true } ); } }>{ !!introVideo && 'youtube.com/watch?v=' + introVideo }</p>
                                    { !!introVideo &&
                                        <span className={ style.clearIcon } onClick={ () => { this.updateVideo( null ); } }>
                                            <Icon source='fontAwesome' icon='far/faTimesCircle' />
                                        </span>
                                    }
                                </div>
                            </div>

                            <Field
                            id='profession_fk'
                            name='profession_fk'
                            label='Profession'
                            component={ FormSelect }
                            fullWidth
                            required
                            options={ professionOptions } />

                            { this.props.password &&
                                <Field
                                id='password'
                                name='password'
                                label='Password'
                                type='password'
                                component={ FormTextField }
                                fullWidth />
                            }

                            <Field
                            id='usertype'
                            name='usertype'
                            label='User Type'
                            component={ FormSelect }
                            options={ [
                                { text: 'Brand Team Member', value: 'brand team member' },
                                { text: 'Brand Team Admin', value: 'brand admin' },
                                { text: 'Expert Team', value: 'pro team admin' },
                                { text: 'Expert', value: 'verified creator' },
                                { text: 'Sales Team', value: 'sales' },
                                { text: 'Account Management Team', value: 'account manager admin' },
                                { text: 'Post Production Team', value: 'post production admin' },
                                { text: 'Shopper (Deprecated)', value: 'shopper' },
                                { text: 'Creator (Deprecated)', value: 'creator' },
                                { text: 'Admin', value: 'admin' },
                            ] } />

                            
                            <div className={ style.categoriesField } >
                                <div className={ style.fieldTitle }>Categories:</div>
                                <p onClick={ () => { this.setState( { showCategorySelect: true } ); } }>{ categories.map( category => category.name ).join( ', ' ) }</p>
                            </div>

                            { this.state.showCategorySelect &&
                                <CategorySelectModal initialValues={ this.props.initialValues.categories ? this.props.initialValues.categories : [] }
                                onSubmit={ this.updateCategories }
                                closeHandler={ () => { this.setState( { showCategorySelect: false } ); } } />
                            }

                            <Field
                            id='website'
                            name='website'
                            label='Personal Website'
                            component={ FormTextField }
                            fullWidth />

                            <Field
                            id='description'
                            name='description'
                            component={ FormTextArea }
                            multiLine={ true }
                            rowsMax={ 2 }
                            label='About'
                            fullWidth />

                            <Field
                            id='xgc_ready'
                            name='xgc_ready'
                            label='XGC Ready'
                            component={ FormToggle }
                            style={ { marginTop: '10px' } } />

                            <Field
                            id='featured'
                            name='featured'
                            label='Featured'
                            component={ FormToggle }
                            style={ { marginTop: '10px' } } />

                            <Field
                            id='deactivated'
                            name='deactivated'
                            label='Deactivated'
                            component={ FormToggle }
                            style={ { marginTop: '10px' } } />


                            <br/>

                            <Field
                            id='amazonsubaffiliateid'
                            name='amazonsubaffiliateid'
                            component={ FormTextField }
                            label='Amazon Subaffiliate ID'
                            fullWidth />

                            <Field
                            id='commisionsubaffiliateid'
                            name='commisionsubaffiliateid'
                            component={ FormTextField }
                            label='Commision Junction Subaffiliate ID'
                            fullWidth />

                            <Field
                            id='rakutensubaffiliateid'
                            name='rakutensubaffiliateid'
                            component={ FormTextField }
                            label='Rakuten Subaffiliate ID'
                            fullWidth />

                            <Field
                            id='targetSubaffiliateId'
                            name='targetSubaffiliateId'
                            component={ FormTextField }
                            label='Target Subaffiliate ID'
                            fullWidth />

                            <PrimaryButton
                            label='Submit'
                            fullWidth
                            type='submit'
                            style={ { marginTop: '45px' } }/>
                        </div>
                    </div>
                </Form>
                { this.state.showVideoSelect &&
                    <VideoImageSelector
                    initialValues={ {
                        selectedImage: this.props.initialValues.bannerImage,
                        youtube: 'https://www.youtube.com/watch?v=' + this.props.initialValues.intro_video,
                    } }
                    closeHandler={ () => { this.setState( { showVideoSelect: false } ); } }
                    onSubmit={ this.updateVideo } />
                }
            </div>
        );
    }
}

UserForm = reduxForm( {
    form: 'UserForm',
} )( UserForm );

const mapStateToProps = ( state ) => {
    return {
        listInterests: state.vars.interests,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'UserForm', field, value ) );
        },
        getProfessionOptions: () => {
            return dAPI.get( '/professions' );

        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( UserForm );
